import { createMiddlewareAction } from './createMiddlewareAction'
import { endpointsEventos } from '../api/endpoints'
import { eventosTypes } from '../constantes/actionTypes'

export const eventosActions = {
  getAllEventos: () =>
    createMiddlewareAction({
      successType: eventosTypes.GET_ALL_EVENTOS_SUCCESS,
      failureType: eventosTypes.GET_ALL_EVENTOS_FAILURE,
      method: 'GET',
      endpoint: endpointsEventos.GET_ALL_EVENTOS,
    }),

  createEvento: (evento) =>
    createMiddlewareAction({
      successType: eventosTypes.NEW_EVENTO_SUCCESS,
      failureType: eventosTypes.NEW_EVENTO_FAILURE,
      method: 'POST',
      endpoint: endpointsEventos.NEW_EVENTO,
      body: evento,
    }),

  updateEvento: (evento) =>
    createMiddlewareAction({
      successType: eventosTypes.UPDATE_EVENTO_SUCCESS,
      failureType: eventosTypes.UPDATE_EVENTO_FAILURE,
      method: 'PUT',
      endpoint: endpointsEventos.UPDATE_EVENTO,
      body: evento,
    }),

  deleteEvento: (id) =>
    createMiddlewareAction({
      successType: eventosTypes.DELETE_EVENTO_SUCCESS,
      failureType: eventosTypes.DELETE_EVENTO_FAILURE,
      method: 'DELETE',
      endpoint: endpointsEventos.DELETE_EVENTO(id),
    }),
}
